import type {
  CreateChecklistFailed,
  CreateChecklistRequest,
  CreateChecklistSucceeded,
  DeleteChecklistFailed,
  DeleteChecklistRequest,
  DeleteChecklistSucceeded,
  LoadChecklistFailed,
  LoadChecklistRequest,
  LoadChecklistsFailed,
  LoadChecklistsSucceeded,
  LoadChecklistSucceeded,
  LoadCompletedChecklistsNamesFailed,
  LoadCompletedChecklistsNamesRequest,
  LoadCompletedChecklistsNamesSucceeded,
  LoadCompletedChecklistsRequest,
  LoadTemplateChecklistsRequest,
  UpdateChecklistFailed,
  UpdateChecklistRequest,
  UpdateChecklistSucceeded,
} from './actions';
import { ChecklistActionTypes } from './actionTypes';

import type { DateRange, Sort, UUID } from '@cobliteam/common-types';

import type { Checklist, ChecklistsNames, ChecklistsPage, NewChecklist, UpdatedChecklist } from '@cobliteam/api-lib';

export const loadCompletedChecklistsRequest = (
  period?: DateRange,
  page?: number,
  size?: number,
  sort?: Sort,
  inputFilter?: string,
  nameFilters?: string[]
): LoadCompletedChecklistsRequest => ({
  type: ChecklistActionTypes.LOAD_COMPLETED_CHECKLISTS_REQUEST,
  payload: {
    period,
    page,
    size,
    sort,
    inputFilter,
    nameFilters,
  },
});

export const loadTemplateChecklistsRequest = (): LoadTemplateChecklistsRequest => ({
  type: ChecklistActionTypes.LOAD_TEMPLATE_CHECKLISTS_REQUEST,
});

export const loadChecklistsSucceeded = (checklistsPage: ChecklistsPage, template: boolean): LoadChecklistsSucceeded => ({
  type: ChecklistActionTypes.LOAD_CHECKLISTS_SUCCEEDED,
  payload: {
    checklistsPage,
    template,
  },
});

export const loadChecklistsFailed = (template: boolean): LoadChecklistsFailed => ({
  type: ChecklistActionTypes.LOAD_CHECKLISTS_FAILED,
  payload: template,
});

export const loadChecklistRequest = (checklistId: UUID): LoadChecklistRequest => ({
  type: ChecklistActionTypes.LOAD_CHECKLIST_REQUEST,
  payload: checklistId,
});

export const loadChecklistSucceeded = (checklist: Checklist): LoadChecklistSucceeded => ({
  type: ChecklistActionTypes.LOAD_CHECKLIST_SUCCEEDED,
  payload: checklist,
});

export const loadChecklistFailed = (): LoadChecklistFailed => ({
  type: ChecklistActionTypes.LOAD_CHECKLIST_FAILED,
});

export const loadCompletedChecklistsNamesRequest = (): LoadCompletedChecklistsNamesRequest => ({
  type: ChecklistActionTypes.LOAD_COMPLETED_CHECKLISTS_NAMES_REQUEST,
  payload: false,
});

export const loadCompletedChecklistsNamesSucceeded = (checklistsNames: ChecklistsNames): LoadCompletedChecklistsNamesSucceeded => ({
  type: ChecklistActionTypes.LOAD_COMPLETED_CHECKLISTS_NAMES_SUCCEEDED,
  payload: checklistsNames,
});

export const loadCompletedChecklistsNamesFailed = (): LoadCompletedChecklistsNamesFailed => ({
  type: ChecklistActionTypes.LOAD_COMPLETED_CHECKLISTS_NAMES_FAILED,
});

export const createChecklistRequest = (checklist: NewChecklist): CreateChecklistRequest => ({
  type: ChecklistActionTypes.CREATE_CHECKLIST_REQUEST,
  payload: checklist,
});

export const createChecklistSucceeded = (createdChecklist: Checklist): CreateChecklistSucceeded => ({
  type: ChecklistActionTypes.CREATE_CHECKLIST_SUCCEEDED,
  payload: createdChecklist,
});

export const createChecklistFailed = (): CreateChecklistFailed => ({
  type: ChecklistActionTypes.CREATE_CHECKLIST_FAILED,
});

export const updateChecklistRequest = (id: UUID, updatedChecklist: UpdatedChecklist): UpdateChecklistRequest => ({
  type: ChecklistActionTypes.UPDATE_CHECKLIST_REQUEST,
  payload: {
    id,
    updatedChecklist,
  },
});

export const updateChecklistSucceeded = (updatedChecklist: Checklist): UpdateChecklistSucceeded => ({
  type: ChecklistActionTypes.UPDATE_CHECKLIST_SUCCEEDED,
  payload: updatedChecklist,
});

export const updateChecklistFailed = (): UpdateChecklistFailed => ({
  type: ChecklistActionTypes.UPDATE_CHECKLIST_FAILED,
});

export const deleteChecklistRequest = (deletedChecklist: Checklist): DeleteChecklistRequest => ({
  type: ChecklistActionTypes.DELETE_CHECKLIST_REQUEST,
  payload: deletedChecklist,
});

export const deleteChecklistSucceeded = (deletedChecklistId: UUID, template: boolean): DeleteChecklistSucceeded => ({
  type: ChecklistActionTypes.DELETE_CHECKLIST_SUCCEEDED,
  payload: {
    deletedChecklistId,
    template,
  },
});

export const deleteChecklistFailed = (): DeleteChecklistFailed => ({
  type: ChecklistActionTypes.DELETE_CHECKLIST_FAILED,
});
